import moment from "moment";
import { s3AutomationPrivate } from "../../../../utils/aws";
import {
  uploadFileToS3, getUser, getFileFromS3, getAppVersion, convertUnit8ArrayToJson,
} from "../../../../utils/helpers";

// check if the files exists on s3
// if it does not, create a file with a empty list then send the log to the backend
// if it does, just send the log to the backend
// eslint-disable-next-line import/prefer-default-export
export const SendLog = async (log, time, path = "send_reports/") => {
  try {
    const fileName = `media/automation/logs/${path}${moment(time).format("YYYY-MM")}.json`;
    const logData = {};
    const formatted_time = moment(time).format("MM/DD/YY, hh:mm:ss A");
    const userDetails = getUser();
    log.version = getAppVersion();
    log.user = userDetails.email;
    log.role = userDetails.role;
    logData[formatted_time] = log;
    const response = await getFileFromS3(fileName, s3AutomationPrivate);
    let data;
    if (response.success) {
      data = convertUnit8ArrayToJson(response.data);
      data.unshift(logData);
    } else if (response.errorCode === "NoSuchKey") {
      data = [logData];
    } else {
      return; // unknown error return here
    }
    const dataObj = JSON.stringify(data);
    const file = new Blob([dataObj], { type: "application/json" });
    const fileObj = {
      file,
      key: fileName,
      type: "application/json",
    };
    uploadFileToS3(fileObj, s3AutomationPrivate);
  } catch (e) {
    console.log("Something went wrong: ", e);
  }
};

// import axios from "axios";
// import { getUser } from "./helpers";
// import logger from "../../../../actions/logger";

// export const logAPI = () => {
//   const logEndPoints = [
//     "getreports",
//     "getwodata",
//     "environment_report",
//     "product_report",
//     "sendreports",
//     "updatereports",
//     "pendingreports",
//     "deletereports",
//   ];
//   axios.interceptors.request.use((request) => {
//     const logEndPoint = logEndPoints.some((endPoint) =>
//       request.url.includes(endPoint)
//     );
//     if (request.method === "post" && logEndPoint) {
//       const log = {
//         url: `${request.url}`,
//         user: getUser()?.email || "",
//         userID: getUser()?.id || "",
//         method: `${request.method}`,
//         data: request.data,
//       };
//       const time = new Date().toLocaleString();
//       SendLog(log, time);
//     }
//     return request;
//   });

//   axios.interceptors.response.use(
//     (response) => {
//       const log = {
//         url: `${response.config.url}`,
//         status: response.status,
//         user: getUser()?.email || "",
//         userID: getUser()?.id || "",
//         method: `${response.config.method}`,
//         response: response.data,
//       };
//       const time = new Date().toLocaleString();
//       const logEndPoint = logEndPoints.some((endPoint) =>
//         response.config.url.includes(endPoint)
//       );
//       if (logEndPoint) {
//         SendLog(log, time);
//       }
//       return response;
//     },
//     function (error) {
//       const log = {
//         url: `${error.config.url}`,
//         status: error.message,
//         user: getUser()?.email || "",
//         userID: getUser()?.id || "",
//         method: `${error.config.method}`,
//       };
//       const time = new Date().toLocaleString();
//       const logEndPoint = logEndPoints.some((endPoint) =>
//         error.config.url.includes(endPoint)
//       );
//       if (logEndPoint) {
//         SendLog(log, time);
//       }
//       return Promise.reject(error);
//     }
//   );
// };

// export const SendLog = async (log, time) => {
//   const fileName = `media/automation/logs/send_reports/${moment(time).format("YYYY-MM")}.json`;
//   let logData = {};
//   logData[time] = log;
//   const payload = {
//     key: fileName,
//     result: [logData]
//   };
//   checkLogFileOnS3(fileName).then( async (logFile) => {
//     if(logFile) {
//       logger(payload)
//     } else {
//       const emptyList = "[]" //Backend needs a empty list in the file to append the data
//       const file = new Blob([emptyList], { type: "application/json" });
//       const response = await addFileToAWS(file, fileName)
//       if(response.success) {
//         logger(payload)
//       } else {
//         console.log("Could not add log file to S3 Bucket", response)
//       }
//     }
//   });
// };

// const checkLogFileOnS3 = (file) => {
//   return new Promise((resolve) => {
//     s3AutomationPrivate.getObject(
//       { Bucket: genistaDevBucket, Key: file },
//       function (error, data) {
//         if (error != null) {
//            return resolve(false);
//         } else {
//           return resolve(true);
//         }
//       }
//     );
//   });
// };

// const updateLocalStorage = (data) => {
//   let currentLog = JSON.parse(localStorage.getItem("automation_log"));
//   let logData = {};
//   const date = moment(new Date().toLocaleDateString()).format("YYYY-MM-DD")
//   logData[data.time] = data.log;
//   const fileName = `media/automation/logs/${date}.json`
//   console.log(fileName)
//   const payload = {
//     key: fileName,
//     result: [logData]
//   };
//   logger(payload)

//   if (!currentLog) {
//     localStorage.setItem("automation_log", JSON.stringify([logData]));
//   } else {
//     localStorage.setItem(
//       "automation_log",
//       JSON.stringify([logData, ...currentLog])
//     );
//   }
//   // uploadLog();
// };

// const uploadLog = async () => {
//   const data = localStorage.getItem("automation_log");
//   TextFile(data, new Date().toLocaleDateString());
//   logger({});
// };

// const TextFile = (data, date) => {
//   let fileName = `${moment(date).format("YYYY-MM-DD")}.json`;
//   const file = new Blob([data], { type: "application/json" });
//   // const email = getUser()?.email || "";
//   // if (email !== "") {
//   //   fileName = `${moment(date).format("YYYY-MM-DD")}_${getUser().email}.json`
//   // }
//   // addFileToAWS(file, fileName);
//   // const element = document.createElement("a");
//   // element.href = URL.createObjectURL(file);
//   // element.download = fileName;
//   // document.body.appendChild(element); // Required for this to work in FireFox
//   // element.click();
// };
